/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  
document.addEventListener("DOMContentLoaded", function() {
    const cartDrawer = document.querySelector(".cart-drawer");
    const body = document.body;
    
    if (cartDrawer) {
        const observer = new MutationObserver(() => {
            if (cartDrawer.classList.contains("is-open")) {
                body.classList.add("cart-open");
            } else {
                body.classList.remove("cart-open");
            }
        });

        observer.observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
    }
});

document.addEventListener('DOMContentLoaded', () => {
    // Affichage de la date actuelle
    const dateElement = document.getElementById('current-date');
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    dateElement.textContent = new Date().toLocaleDateString('fr-FR', options);

    // Gestion de l'envoi de la lettre
    const sendButton = document.getElementById('envoyer-lettre');
    sendButton.addEventListener('click', () => {
        const letterText = document.getElementById('lettre-text').value.trim();
        const consentGiven = document.getElementById('accept-emails').checked;

        if (!letterText) {
            alert("Votre lettre est vide. Veuillez écrire quelque chose.");
            return;
        }

        if (!consentGiven) {
            alert("Veuillez accepter de recevoir des e-mails pour continuer.");
            return;
        }

        // Logique d'envoi de la lettre (à adapter selon vos besoins)
        alert("Votre lettre a été envoyée avec succès !");
    });
});  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
